import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { SnaphotApi as SnaphotApiDev } from '../services/catesservices/api';
import { SnaphotApi as SnaphotApiProd } from '../services/catesservicesprod/api';
import moment from "moment";
import CalendarComponent from "../components/_Helper/Calendar/calendar";
import * as $ from "jquery";
import logo from "../assets/images/rasyonet-line.png";

function News() {
  const snaphotApi = new SnaphotApiDev({
    username: 'cates-crow',
    password: 'nCY6PVfJ*AgtQr+'
  });

  const snaphotProdApi = new SnaphotApiProd({
    username: 'cates-crow',
    password: 'nCY6PVfJ*AgtQr+'
  });

  //#region Page Property
  const { t, i18n } = useTranslation();
  const newsContainerRef = useRef(null);
  //#endregion

  //#region UseState
  const [visible, setVisible] = useState(false); 
  const [newsData, setNewsData] = useState([]); 
  const [newsStatu, setNewsStatu] = useState(true);
  const [selectedLang, setSelectedLang] = useState("");
  const [offset, setOffset] = useState(0);
  const [servicesControl, setServicesControl] = useState();
  const [startDate, setStartDate] = useState(() => {
    let date = new Date();
    date.setMonth(date.getMonth() - 3);
    date.setHours(0, 0, 0, 0);
    return date;
  });
  const [endDate, setEndDate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0))
  );
  let api = servicesControl !== undefined && servicesControl ? snaphotProdApi : snaphotApi;
  //#endregion  

  //#region Change Func
  const startDateChange = (e) => {
    if (e > endDate) {
      setStartDate(endDate);
      setEndDate(e);
    } else setStartDate(e);
  };

  const endDateChange = (e) => {
    if (e < startDate) {
      setEndDate(startDate);
      setStartDate(e);
    } else setEndDate(e);
  };
  //#endregion

  //#region Footer 
  const footerContent = (
    <div>
      <Button
        className="o-custom-button btn btn-secondary"
        onClick={() => setVisible(false)}
      >
        <i className="fas fa-times align-middle"></i> <span>{t("Close")}</span>
      </Button>
    </div>
  );
  //#endregion

  //#region Page Load Data
  const openNewsDetail = (item) => {
    if (api !== undefined && api !== "") {
      api.apiSnaphotNewsDetailGet(item.id, selectedLang === "tr-TR" ? "tr" : "en")
        .then(response => {
          if (response.status === 200) {
            setVisible(true);

            setTimeout(() => {
              let data = response.data;
              let content = data[0].body;
              var parser = new DOMParser();
              var htmlDoc = parser.parseFromString(content, "text/html");

              $(".fa-question-circle", htmlDoc).css("display", "none");
              $("iframe", htmlDoc).each(function (index, element) {
                var iframe = $(this)[index];

                var iframeSrc = $(iframe).attr("src");

                if (iframeSrc.indexOf("embed") === -1) {
                  if (iframeSrc.indexOf("youtu.be") !== -1) {
                    let youtubeSrcId =
                      iframeSrc.split("/")[iframeSrc.split("/").length - 1];

                    $(iframe).attr(
                      "src",
                      "https://www.youtube.com/embed/" + youtubeSrcId
                    );
                  } else if (iframeSrc.indexOf("youtube.com") !== -1) {
                    var youtubeParams = iframeSrc.split("?")[1];

                    var urlParams = new URLSearchParams(youtubeParams);
                    let youtubeSrcId = urlParams.get("v");

                    $(iframe).attr(
                      "src",
                      "https://www.youtube.com/embed/" + youtubeSrcId
                    );
                  }
                }
              });

              var stringHtmlContent = $("body", htmlDoc).html();

              if (stringHtmlContent.substring(0, 5) === "<?xml") {
                $("#newsModalBody").append(stringHtmlContent.split("</head>")[1]);
                $("#newsModalBody .fa-question-circle").remove();
                $("#newsModalBody .gwt-Label").css("text-align", "left");
              } else {
                $("#newsModalBody").append(stringHtmlContent);
              }

              $("#newsModalHeader").html(item.header);
              $("#newsModalHeaderDate").html(moment.utc(item.date).local().format('MM/DD/YYYY HH:mm:ss'))
            }, 100);
          }
        })
    }
  };

  const newsDatas = (offset, dateChange) => {
    if (api !== undefined && api !== "") {
      api.apiSnaphotNewsGet(selectedLang === "tr-TR" ? "tr" : "en", 20, offset, moment(startDate).format("yyyy-MM-DD"), moment(endDate).format("yyyy-MM-DD"))
        .then(response => {
          if (response.status === 200) {
            let data = response.data;
            if (!dateChange) {
              setNewsData(prevData => [...prevData, ...data]);
            }
            else {
              setNewsData(data);
            }
          }
        })
    }
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    let control = typeof window.location !== 'undefined' &&
      window.location.origin.indexOf("localhost") !== -1 ?
      false :
      window.location.origin.indexOf("cates-test.rasyonet") !== -1 ?
        false :
        window.location.origin.indexOf("cates.rasyonet") !== -1 &&
        true;

    setServicesControl(control);

    if (window.location.pathname.indexOf("news") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
    } else setSelectedLang("tr-TR");

    const handleScroll = () => {
      if (newsContainerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = newsContainerRef.current;
        if (scrollTop + clientHeight >= scrollHeight) {
          setOffset((prevOffset) => prevOffset + 20);
        }
      }
    };

    const newsContainer = newsContainerRef.current;
    if (newsContainer) {
      newsContainer.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (newsContainer) {
        newsContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (
      selectedLang != "" &&
      startDate !== undefined &&
      endDate !== undefined
    ) {
      setOffset(0);
      newsDatas(0, true);
      if (newsContainerRef.current) {
        newsContainerRef.current.scrollTop = 0;
      }
    }
  }, [startDate, endDate, selectedLang]);

  useEffect(() => {
    if (offset > 0) {
      newsDatas(offset, false);
    }
  }, [offset])

  useEffect(() => {
    if (newsData.length === 0) setNewsStatu(false);
    else setNewsStatu(true)
  }, [newsData])
  //#endregion

  return (
    <>
      <div className="container-fluid mt-4">      

        <div className={`row mb-5`}>
          <div className="col-md-12">
            <div className="title mb-3">{t("kapNews")}</div>
            <div className="dateArea mb-3">
              <div className="firstDate d-inline-block me-3">
                <CalendarComponent date={startDate} change={startDateChange} lang={selectedLang} />
              </div>
              <div className="lastDate d-inline-block">
                <CalendarComponent date={endDate} change={endDateChange} lang={selectedLang} />
              </div>
            </div>
            <div className={`news d-inline-block position-relative w-100 ${newsStatu ? "" : "d-none"}`} ref={newsContainerRef}>
              <table className="w-100">
                <tbody>
                  {newsData?.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => {
                        openNewsDetail(item);
                      }}
                    >
                      <td>{moment(item.date).format("DD.MM.yyyy hh:mm:ss")}</td>
                      <td>{item.header}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={`news d-flex align-items-center justify-content-center position-relative w-100 ${!newsStatu ? "" : "d-none"}`}>
              {selectedLang === "tr-TR" ? "Özel Durum Açıklaması bulunamadı" : "Public Disclosures not found"}
            </div>
          </div>
        </div>


        {selectedLang === "tr-TR" ?
          <div className="note text-end d-inline-block w-100 mb-3">
             * Piyasa verileri <img src={logo} /> tarafından sağlanmaktadır.
          </div>
          :
          <div className="note text-end d-inline-block w-100 mb-3">
            * The share information data is provided by <img src={logo} />
          </div>
        }
      </div>

      <Dialog
        header="Haber Detayı"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <div id="newsModalHeader" className="mb-2"></div>
        <div id="newsModalHeaderDate" className="mb-3"></div>
        <div id="newsModalHeaderProvider"></div>

        <div className="col-md-12" id="newsModalScrollDiv">
          <div id="newsModalBody" className=""></div>
        </div>
      </Dialog>
    </>
  );
}

export default News;
